// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-bullet-icon{font-size:.6rem;margin-right:0}.list-item-cancelation-reason{font-size:0.875rem;padding-left:0.5rem}\n", ""]);
// Exports
module.exports = exports;
